import React from "react";
import SupportboardHeader from "./supportboardHeader";
import SupportboardFooter from "./supportboardFooter";
import SupportboardBody from "./supportboardBody";

const SupportBoard = ({ chatboardSelectedTab }) => {
  return (
    <>
      <SupportboardHeader />
      <div
        className={`body body-inner ${
          chatboardSelectedTab === "thread" && " flex-column"
        }`}
      >
        <SupportboardBody />
      </div>

      <SupportboardFooter />
    </>
  );
};

export default SupportBoard;
